import { render } from "./OrderInvoiceForm.vue?vue&type=template&id=5702a766&scoped=true"
import script from "./OrderInvoiceForm.vue?vue&type=script&lang=js"
export * from "./OrderInvoiceForm.vue?vue&type=script&lang=js"

import "./OrderInvoiceForm.vue?vue&type=style&index=0&id=5702a766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5702a766"]])

export default __exports__